import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import type Store from '@ember-data/store';
import type { ModelSchema } from '@ember-data/store/types';
import ApplicationSerializer from 'lumen/serializers/application';
import {
  addIdToSegmentationValueData,
  type RevenueInsightSegmentationValue,
} from 'lumen/utils/revenue-insight/model-utils';

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
export default class RevenueInsightSegmentationValueSerializer extends ApplicationSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    value: { embedded: 'always' },
    referenceValue: { embedded: 'always' },
    forecastReference: { embedded: 'always' },
    budgetValue: { embedded: 'always' },
    forecastValue: { embedded: 'always' },
    cancellationValue: { embedded: 'always' },
    cancellationReferenceValue: { embedded: 'always' },
    cancellationValueFiltered: { embedded: 'always' },
    cancellationReferenceValueFiltered: { embedded: 'always' },
    'value.reservations': { embedded: 'always' },
    'referenceValue.reservations': { embedded: 'always' },
  };

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  modelNameFromPayloadKey() {
    return 'revenue-insight/segmentation-value';
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  normalizeQueryResponse(
    store: Store,
    primaryModelClass: ModelSchema,
    payload: Record<string, RevenueInsightSegmentationValue[]>,
    id: string | number,
    requestType: string,
  ) {
    // Add `id` to each segmentation-value's segmentation-data object.
    // Necessary because backend does not provide an `id` for these objects.
    // Can't use extractId in revenue-insight/segmentation-data as we want existing store instances
    // to be overwritten when e.g. a new filter is applied (should result in same id).
    Object.values(payload).forEach((segmentationValues) => {
      segmentationValues.forEach((segmentationValue) => {
        addIdToSegmentationValueData(segmentationValue);
      });
    });

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return super.normalizeQueryResponse(
      store,
      primaryModelClass,
      payload,
      id,
      requestType,
    );
  }
}
